<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <SoftOneApiForm
            :default-data="thirdPartyService"
            :action="updateSoftOneApiService"
            @cancel="$refs.modal.close()"
          />
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import { softOneApiServicesClient } from '@/api/clients';
import SoftOneApiForm from './SoftOneApiForm.vue';

export default {
  components: {
    SoftOneApiForm,
    BaseCard,
  },
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    thirdPartyService() {
      return this.$store.state.entities.thirdPartyServices.byId[this.thirdPartyServiceId];
    },
  },
  methods: {
    async updateSoftOneApiService(formData) {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.thirdPartyServiceId,
          formData: { config: formData },
          service: softOneApiServicesClient.update,
        });

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
